import React from "react";
import { Center, Spinner, CenterProps, SkeletonText } from "@chakra-ui/react";

interface Props extends CenterProps {
  isSkeleton?: boolean
}

const LoadingOverlay = ({ isSkeleton, ...props }: Props) => (
  <Center h="100%" w="100%" {...props}>
    {isSkeleton && (
      <SkeletonText
        data-testid="skeleton-text"
        noOfLines={15}
        spacing="10px"
        p="10px 18px"
        width="100%"
      />
    )}

    {!isSkeleton && (
      <Spinner size="xl" />
    )}
  </Center>
);

export default LoadingOverlay;
